import rows from "../../styles/HorizontalScroll.module.css";
import styles from "../../styles/RowsSkeleton.module.css";

const CARDS = 14;

// Placeholder rows shown in the homepage personal-rows slot while "Continue Playing" / "Recommended For You"
// load. Built from the same row classes as HorizontalScroll so it takes exactly the space the real rows will.
// Hidden unless html[data-returning] is set (only returning visitors get personal rows).
// One row per element, so swapping a placeholder for its real row moves nothing else (no layout shift).
//   kind: "compact" (Continue Playing, history visitors only) or "single"
export default function RowsSkeleton({ kind }) {
  return (
    <div className={kind === "compact" ? `${styles.skeleton} ${styles.compactRow}` : styles.skeleton} aria-hidden="true">
      {/* Continue Playing has no heading line: its heading is the row's first card */}
      {kind !== "compact" && <div className={rows.header}>
        <div className={rows.header_container}>
          <div className={styles.heading}><span className={styles.bar} /></div>
        </div>
        <div className={`${rows.header_container2} ${styles.hidden}`}>
          <div className={rows.scrollButton}>◀</div>
          <div className={rows.scrollButton}>▶</div>
        </div>
      </div>}
      <div className={`${rows.game_section} ${styles.section}`}>
        <div className={kind === "compact" ? `${rows.grid_container2} ${rows.compact}` : rows.grid_container2}>
          {kind === "compact" && <div className={`${rows.labelCard} ${styles.shimmer} ${styles.labelGhost}`} />}
          {Array.from({ length: CARDS }, (_, i) => (
            <div key={i} className={`${rows.thumb_1x1} ${styles.card}`}>
              <div className={rows.thumb_container}>
                <div className={`${styles.shimmer} ${styles.image}`} />
                {kind !== "compact" && <div className={`${styles.shimmer} ${styles.title}`} />}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
